import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import Thanks from './Thanks';
import {
    runValidation
} from '../helpers/Validation';

const $= window.$;

class DigitalEvaluation extends Component {
	constructor(props) {
		super(props);

        this.state={
            det : this.props.params.det,
            assessor_evaluation:[],
            assessors_name:'',
            Asssex:'',
            sex:'',
            full_name:'',
            evaluation_questionaire:[],
            photo:'',
            evaluation_question:[],
            compolist:[],
            thanksPage: ''
        };
        
	}
  fnEvaluationFormValidate(){
    let learnerID = Common.getUserData("id", true);
    if (runValidation('evaluation-block')) {
      let formData = new FormData();
      let evaluation_form = $('#evaluation_form').serializeArray();

      evaluation_form.map((key, index) => {
        formData.append(key.name, key.value);
      });

    formData.append('det',this.state.det);
      
      fetch(Config.domainUrl+'evaluation/assessor-evaluation-insert', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    //'Content-Type': 'application/json',
                    'Authorization':'Bearer ' +Common.getTokenData()
                  },

                    body: formData
                  }).then((response) => response.json())
                 .then((responseJson) => {                
                  if(responseJson.status != 0 ){
                    let data = {
                      "status": "completed",
                      "learning_room_id": responseJson.details.learning_room_id,
                      "compseq_id": responseJson.details.compseq_id,
                      "divider_id": 0,
                      "dlr_id": 0,
                      "learner_id": learnerID,
                      "is_ag": 0,
                      "id": 0,
                      "compo_type": "thanks",
                      "look_before": responseJson.details.compseq_id,
                      "flowresult": true
                    };
                    this.setState({
                        thanksPage: <Thanks data={data} usableType="webapp" switchback={this.state.compolist}/>
                      });
                  }

         });
      }

  }

	getAssessorEvaluation(){

    	fetch(Config.domainUrl+'evaluation/assessor-evaluation', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                  	det : this.state.det,
                    domain:Config.domainUrl,
                  })
                }).then((response) => response.json())
               .then((responseJson) => {               	
               	if(responseJson.status != 0 ){
                  
                  let assessor_evaluation=(responseJson.assessor_evaluation!=undefined) ? responseJson.assessor_evaluation : '';
                  // alert(JSON.stringify(assessor_evaluation));
                  let assessors_name=(responseJson.assessor_evaluation.assessors_name!=undefined) ? responseJson.assessor_evaluation.assessors_name : '';
                  let Asssex=(responseJson.assessor_evaluation.Asssex!=undefined) ? responseJson.assessor_evaluation.Asssex : '';
                  let photo=(responseJson.assessor_evaluation.photo!=undefined) ? responseJson.assessor_evaluation.photo : '';
                  let sex=(responseJson.assessor_evaluation.sex!=undefined) ? responseJson.assessor_evaluation.sex : '';
                  let full_name=(responseJson.assessor_evaluation.full_name!=undefined) ? responseJson.assessor_evaluation.full_name : '';
                  let evaluation_questionaire=(responseJson.assessor_evaluation.evaluation_questionaire!=undefined) ? responseJson.assessor_evaluation.evaluation_questionaire : '';
                  let evaluation_question=(responseJson.assessor_evaluation.evaluation_question!=undefined) ? responseJson.assessor_evaluation.evaluation_question : '';
                  
	               	this.setState({
	               	   	assessor_evaluation:assessor_evaluation,
                      assessors_name:assessors_name,
                      Asssex:Asssex,
                      sex:sex,
                      full_name:full_name,
                      evaluation_questionaire:evaluation_questionaire,
                      photo:photo,
                      evaluation_question:evaluation_question,
	               	});
               	}

   		 });
    }

    componentDidMount() {

      let div = document.querySelector('body');
  		div.id = 'bodyid';
  		div.setAttribute('class','inner');
  		this.getAssessorEvaluation();

    }

  

		render() {
			
			let monthNames = Common.monthNames;
			let d=new Date(), jDate=d.getDate(), jMonth=monthNames[d.getMonth()], jYear=d.getFullYear();

      let question = null;
        if(this.state.evaluation_questionaire!=null || this.state.evaluation_questionaire!=undefined) {
          question= this.state.evaluation_questionaire.map((key,index)=>{
              return <div>
                          <div className="slash_txt"> <span className="ev_active_button" title={key.alt_text}>
                        {key.icon}
                        </span>
                        <div className="lm_txt"> <span className="lm_title">
                          {key.eval_question_name}
                          </span> <span className="blue">Number of Questions :
                          {key.no_of_questions}
                          </span> </div>
                        <div className="slash_txt"><br />
                          {key.eval_welcome_message}
                        </div>
                      </div>
                      <div>
                        <div className="score_box" style={{width:'750px'}}> <span className="score_explanation">Rating Explanation</span>
                          <pre><font size='2' face='arial'>{key.scoring_explanation} </font> </pre>                          
                        </div>
                      </div>
                      </div>
                });
              } 

              let select_question = null;
              let r =0;
              if(this.state.evaluation_question!=null || this.state.evaluation_question!=undefined) {
                select_question= this.state.evaluation_question.map((key,index)=>{
                      let rate = [];
                      for(r=key.eval_from; r<=key.eval_to; r++) {
                         rate.push(<option value={r}>{r}</option>);
                      }
                      let index_val = index+1;
                    return <tbody id="evaluation-block"><input type="hidden" id={`hidQuestionId[${index_val}]`} name={`hidQuestionId[${index_val}]`} value={key.eval_question_id_pk}/>
                            <tr>
                              <td><div style={{padding:'7px 0px'}}><a name={`bookmark${index_val}`}></a> <span className="question_txt" style={{width:'100%'}}>
                                  
                                  {index_val} . {key.eval_question}
                                  <br />
                                  <select className="cmbbox required  evaluation-block" name={`cmbRate[${index_val}]`} id={`cmbRate${index_val}`}>
                                    <option value="">--Select--</option>
                                    {rate}
                                  </select>
                                  </span> </div></td>
                            </tr>
                            <tr>
                              <td><div id={`divAnswer${index_val}`} className="errorAsssor" style={{display:'none'}}><font color='#FF0000'></font></div></td>
                            </tr>
                          </tbody>
                      });
                    }            

			return (
				<div className="row">
					<header>
						<div className="logo"><img src={process.env.PUBLIC_URL+'/images/logo.png'} alt="361°minds&trade;" title="361°minds&trade;" border="0"/></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL+'/images/calendar_icon.png'} alt="" title="" border="0"/>{this.state.dated}</div>
					</header>
					<section className="maincontent"> 
    <section className="content"> 
      <div className="pageheight">
                        {
                            this.state.thanksPage === "" &&
                            <div>
                        <h1>Welcome <span>
          {this.state.Asssex}    {this.state.assessors_name} </span></h1>
        <div className="margtop"> Thank you for being here. Please read the rating explanation before you begin answering.
          <table width="100%" cellspacing="0" cellpadding="0" border="0">
            <tbody><tr>
              <td width="80%"><table align="center" width="100%" border="0">
                  <tbody><tr>
                    <td>{question}</td>
                    <td width="20%" valign="top">
                      <table align="center" width="100%" border="0">
                        <tbody><tr>
                          <td align="center">   <img src={this.state.photo} className="border" alt="" width="50" border="0" />
                            </td>
                        </tr>
                        <tr>
                          <td align="center"><span className="date_small"><span className="date_red">
                            {this.state.full_name}  </span> </span></td>
                        </tr>
                      </tbody></table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <form name="evaluation_form" id="evaluation_form" method="post" action="" >
                        <table width="100%" cellspacing="0" cellpadding="0" border="0">
                          {select_question}
                           <tr>
                            <td height="50"><div className="button"><span>
                                <input type="button" name="submit" value="Submit" onClick={(e)=>this.fnEvaluationFormValidate()} />
                                </span></div></td>
                          </tr>
                        </table>
                      </form></td>
                  </tr>
                </tbody></table>
                </td>
                  </tr>
                </tbody></table>
                
            
          
        </div>
        </div>
      }
      {
          this.state.thanksPage !== "" &&
          this.state.thanksPage
      }
      </div> 
    </section>
  </section> 
					<footer>
						<span>Copyright &copy; 2006-{jYear},</span>
						<span>Threesixtyone Degree Minds Consulting Pvt Ltd.</span>
						<span className="f-lnk"><a href="javascript:void(0);">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0);">Legal</a></span>
					</footer>
				</div>
			);
		}
}

export default DigitalEvaluation;



// WEBPACK FOOTER //
// ./src/lr_dlr_components/DigitalEvaluation.js